import React from "react";

import "./styles/footer.css";

const Footer = () => {
	return (
		<React.Fragment>
			<div className="footer">
				<div className="footer-location">
					<p>Hyderabad, India</p>
				</div>

				<div className="footer-credits">
					<p>© 2026 Hrithik Agarwal</p>
				</div>
			</div>
		</React.Fragment>
	);
};

export default Footer;
